export const FORM_SOURCE = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  NONE: 'none',
}